/**
 * Explicit game states.
 *
 * The round runs in a fixed order and each step has one owner:
 *
 *   Loading -> Ready -> Countdown -> Playing -> Scored | BallLost -> Ready ...
 *
 * `Countdown` is the AIMING WINDOW. The ball is held above the board and the
 * player turns it, so the descent is chosen before the ball is released. That
 * window is the whole reason the state exists - it is not a cosmetic pause.
 */
export enum GameState {
  /** Assets and the physics world are still being prepared. */
  Loading = 'loading',
  /** Start screen is up, waiting for the player to begin. */
  Ready = 'ready',
  /** 3-2-1 is running. The board responds to input; the ball is held. */
  Countdown = 'countdown',
  /** Ball released and live; the board still responds to input. */
  Playing = 'playing',
  /** The ball has fallen out of the machine without reaching a pocket. */
  BallLost = 'ball-lost',
  /** The ball reached a pocket; the result is being shown. */
  Scored = 'scored',
  /** Round is over; waiting to restart. */
  GameOver = 'game-over',
}
